/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  
  /* @ngdoc object
   * @name heartbeat
   * @description
   *
   */
  angular
    .module('vcutils.heartbeat', [
      'ui.router',
      'knalli.angular-vertxbus'
    ]);
}());
